import { Injectable } from '@angular/core';
import {
  Account,
  createAccountObject,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { Subject } from 'rxjs';
import { StorageService } from './services/storage.service';
import { getAccount } from './api/account';

export const SUBSCRIBED_STAGES = 'subscribed_stages';

@Injectable({
  providedIn: 'root',
})
export class SubscribeService {
  public subscribeSubject = new Subject();

  constructor(private storageService: StorageService) {
    this.initialize();
  }

  initialize = () => {
    this.loadSubscribedStages();
  };

  toggleSubscribe = (account: Account) => {
    if (account.isSubscribed) {
      this.removeAccountFromLocalStorage(account.handle);
      account.setSubscribed(false);
    } else {
      this.addAccountToLocalStorage(account.handle);
      account.setSubscribed(true);
    }
    this.subscribeSubject.next(this.getSubscribedAccountHandles());

    return account.isSubscribed;
  };

  getSubscribedAccountHandles = () => {
    const item = localStorage.getItem(SUBSCRIBED_STAGES);
    return !item ? [] : (JSON.parse(item) as string[]);
  };

  addAccountToLocalStorage = (handle: string) => {
    const accounts = this.getSubscribedAccountHandles();
    if (!accounts) {
      localStorage.setItem(SUBSCRIBED_STAGES, JSON.stringify([handle]));
      return;
    }

    localStorage.setItem(
      SUBSCRIBED_STAGES,
      JSON.stringify([...accounts, handle])
    );
  };

  removeAccountFromLocalStorage = (handle: string) => {
    const accounts = this.getSubscribedAccountHandles();
    if (!accounts) {
      localStorage.setItem(SUBSCRIBED_STAGES, '[]');
      return;
    }

    const index = accounts.indexOf(handle);
    if (index < 0) return;

    localStorage.setItem(
      'subscribed_stages',
      JSON.stringify(accounts.filter((account) => account !== handle))
    );
  };

  loadSubscribedStages = async () => {
    const stages = JSON.parse(
      localStorage.getItem('subscribed_stages')
    ) as string[];

    if (!stages || stages.length === 0) {
      return;
    }

    const requests = stages.map((stage) => getAccount(stage));

    const results = await Promise.allSettled(requests);
    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        this.storageService.saveAccount(createAccountObject(result.value));
        return;
      }

      if (result.reason.status === 404) {
        this.removeAccountFromLocalStorage(stages[index]);
      }
    });
  };
}
